import { apiClient } from "../../lib/axios";

export type ClientEventCategory = "weather" | "operational" | "other";

export interface ClientEvent {
  id: string;
  clientId: string;
  eventDate: string; // YYYY-MM-DD
  title: string;
  description: string | null;
  category: ClientEventCategory;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ClientEventsResponse {
  data: { events: ClientEvent[] };
}

export interface CreateClientEventInput {
  client_id: string;
  event_date: string;
  title: string;
  description?: string | null;
  category?: ClientEventCategory;
}

export interface UpdateClientEventInput {
  event_date?: string;
  title?: string;
  description?: string | null;
  category?: ClientEventCategory;
}

export const clientEventsApi = {
  list: async (params: {
    client_id: string;
    start_date?: string;
    end_date?: string;
  }): Promise<ClientEventsResponse> => {
    const response = await apiClient.get("/admin/client-events", { params });
    return response.data;
  },

  create: async (
    input: CreateClientEventInput,
  ): Promise<{ data: { event: ClientEvent } }> => {
    const response = await apiClient.post("/admin/client-events", input);
    return response.data;
  },

  update: async (
    id: string,
    input: UpdateClientEventInput,
  ): Promise<{ data: { event: ClientEvent } }> => {
    const response = await apiClient.patch(`/admin/client-events/${id}`, input);
    return response.data;
  },

  remove: async (id: string): Promise<{ data: { id: string } }> => {
    const response = await apiClient.delete(`/admin/client-events/${id}`);
    return response.data;
  },
};
